/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from '@reach/router';
import { Button, Grid, Typography, Paper, IconButton } from '@material-ui/core';
import OtpInput from 'react-otp-input';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import Loader from '../../components/Loader';
const { getQRValue, selectDesktop } = Slices.appSlice;
const { selectOtpDigits, selectCountryValidations } = Slices.configSlice;
const { sendOtp, verifyOtpGuest } = Slices.authSlice;
const { getProfile } = Slices.profileSlice;
import { Badge } from '../../components/Icons';
import Cookies from 'js-cookie';
const { getCart, sendCart } = Slices.cartSlice;
import MobileHeader from './../../components/Header/MobileHeader';
import Edit from '../VerifyOTP/images/edit.svg';
import Info from '../VerifyOTP/images/info.svg';
import css from './index.module.scss';
const { selectDefaultAddress, postAddressPickup } = Slices.addressSlice;
import {
  loginAttemptGA,
  loginFailureGA,
  loginSuccessGA,
  otpViaEmailGA,
  requestOtpEmailGA,
  otpResponseEmailGA,
  otpRequestAgainEmailGA,
  otpRequestAgainMobileGA,
} from 'spwa-ui-library/esm/utils/helperGA';

// TODO: Do not use a separate container for OTP
// TODO: Find a way to avoid setting proxy in package.json

function GuestOTP() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const auth = useSelector((state) => state.auth);
  const maxLength = useSelector(selectOtpDigits);
  const cart = useSelector((state) => state.cart);
  const address = useSelector(selectDefaultAddress);
  const loginQR = useSelector(getQRValue);
  const defaultTimerDuration = 45;
  const { otpId, phnNo, oldLocation, retUrl = '/home', email, isEmailVerify } =
    location.state || {};
  const profile = useSelector((state) => state.profile);
  const [errorText, setErrorText] = useState('');
  const [timeOutButton, setTimeOutButton] = useState(false);
  const [disableButton] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [otp, setOtp] = useState('');
  const [timerDuration, setTimerDuration] = useState(defaultTimerDuration);
  // const [dialogState, setDialogState] = useState(true);
  // eslint:fix config is assigned a value but is never used
  const countryName = profile?.country?.toUpperCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const userType = email ? 'Existing' : 'New';

  // const handleResendOtp = () => {
  //   setOtp('');
  //   dispatch(sendOtp({ cCode: countryValidations?.defaultCCode, phnNo })).catch((err) => {
  //     console.log(err);
  //   });
  //   setTimerDuration(defaultTimerDuration);
  //   setErrorText('');
  // };

  const handleResendOtp = () => {
    if (email && email !== '') {
      otpRequestAgainEmailGA();
    } else {
      otpRequestAgainMobileGA();
    }
    setOtp('');
    if (!email) {
      dispatch(
        sendOtp({
          cCode: countryValidations?.defaultCCode,
          phnNo,
          sendOtpVia: 'OTP',
          country: countryName,
        })
      ).catch((err) => {
        console.log(err);
      });
    } else {
      dispatch(
        sendOtp({
          cCode: countryValidations?.defaultCCode,
          phnNo: phnNo,
          email: email || auth?.otpState?.data?.email,
          otpId: otpId,
          sendOtpVia: 'OTP',
          country: countryName,
          otpVia: 'EMAIL',
        })
      ).catch((err) => {
        console.log(err);
      });
    }
    setTimerDuration(defaultTimerDuration);
    // setEndTime(getExpiryDate());
    setErrorText('');
  };

  const isDesktop = useSelector(selectDesktop);
  // const handleClose = () => {
  //   setDialogState(false);
  //   navigate('/home');
  // };
  // eslint:fix handleClose is declared but is never used
  const mergeAddress = () => {
    if (Object.entries(address).length) {
      if (address.addressSubType !== 'DELIVERY') {
        const addressPayload = {
          addressSubType: address.addressSubType,
          addressType: address.addressType,
          addressVia: 'DEFAULT',
          areaId: address.areaId,
          storeId: address.storeId,
        };
        dispatch(postAddressPickup(addressPayload));
      }
      // MS converting guest profile to login profile and copying the same address of the guest.
      // else if (address.addressSubType === 'DELIVERY') {
      //   const deliveryPayload = {
      //     addressSubType: address.addressSubType,
      //     addressType: address.addressType,
      //     addressVia: 'DEFAULT',
      //     bldgName: address.bldgName,
      //     description: address.description,
      //     flatNum: address.flatNum,
      //     howToReach: address.howToReach,
      //     lat: address.lat,
      //     lng: address.lng,
      //     tag: address.tag,
      //   };
      //   dispatch(postAddress(deliveryPayload));
      // }
    }
  };

  const mergeCart = (cartPayload) => {
    const items = cart.data.items;
    const payload = {
      body: {
        addressSubType: address.addressSubType,
        addressId: address?.id || '',
        cartId: cartPayload.cartId,
        applySurprisePromo: cart.data?.promo?.couponCode?.length > 0,
        clusterId: cart.data?.clusterId || '',
        items: items,
        version: 'v20',
        addressType: cart.data.orderType,
        storeId: address?.storeId,
      },
      headers: { country: cart.data.country },
    };

    dispatch(sendCart(payload)).then((res) => {});
  };

  const handleOtpVerify = () => {
    // setDisableButton(true);
    loginAttemptGA(loginQR);
    setPageLoader(true);
    dispatch(
      verifyOtpGuest({
        country: countryName,
        otpId: otpId || '',
        isGuest: 0,
        otp: otp || '',
        verifyOtpVia: 'GUEST',
      })
    ).then((resp) => {
      if (resp?.payload) {
        dispatch(getProfile());
        loginSuccessGA(loginQR, resp?.payload.data.data);
        const cartPayload = {
          cartId: resp.payload.data.data.cartId,
          cartUpdatedAt: resp.payload.data.data.updatedAt,
        };
        if (Object.entries(address).length) {
          mergeAddress();
        }
        if (cart.data.items) {
          mergeCart(cartPayload);
        } else {
          dispatch(getCart(cartPayload));
        }
        if (resp?.payload?.data?.data?.profileStep === 0) {
          setOtp('');
          navigate(`/${intl.locale}/create-profile`, {
            state: {
              oldLocation: JSON.parse(JSON.stringify(oldLocation)),
              mobile: phnNo,
            },
            replace: true,
          });
        } else {
          setOtp('');
          if (cart.data.items.length) {
            navigate(`/${intl.locale}/checkout`, { replace: true });
          } else {
            navigate(`/${intl.locale}/cart`, { replace: true });
          }
        }
      } else {
        setErrorText(resp.error?.message);
        loginFailureGA(loginQR);

        if (resp.error?.message.toLowerCase().includes('max')) {
          setTimeOutButton(true);
        }
        // setOtp('');
      }
      setPageLoader(true);

      // if (resp.payload.data.data.profileStep === 0) {
      //   navigate('/create-profile');
      // } else {
      //   navigate(retUrl);
      // }
    });
  };

  useEffect(() => {
    if (timerDuration > 0) {
      setTimeout(() => {
        setTimerDuration(timerDuration - 1);
      }, 1000);
    }
  }, [otp, timerDuration]);

  const handleLogin = () => {
    // console.log(location);
    navigate(`/${intl.locale}/guest`, { state: { oldLocation: oldLocation }, replace: true });
  };

  // const titleDesc = (
  //   <Grid className={css.textContainer}>
  //     {isDesktop && (
  //       <>
  //         <div className={css.badge}>
  //           <Badge />
  //         </div>
  //         <div className={css.title}>
  //           <FormattedMessage id="otp" defaultMessage="One Time Password" />
  //         </div>
  //       </>
  //     )}
  //     <Typography className={css.headerText}>
  //       <FormattedMessage id="guestotp_otp" defaultMessage="Please enter the 4 digit OTP sent to" />
  //       <span>
  //         {isDesktop ? (
  //           <Grid className={css.warningText}>
  //             {email && email !== '' && isEmailVerify ? (
  //               <span>{email || auth?.otpState?.data?.email}</span>
  //             ) : (
  //               <>
  //                 <span>
  //                   {countryValidations?.defaultCCode} {phnNo}
  //                 </span>
  //                 <img src={Edit} onClick={handleLogin} />
  //               </>
  //             )}
  //           </Grid>
  //         ) : (
  //           <>
  //             {email && email !== '' && isEmailVerify ? (
  //               <>
  //                 <span>
  //                   <span>{email || auth?.otpState?.data?.email}</span>
  //                 </span>
  //               </>
  //             ) : (
  //               <>
  //                 <span>{countryValidations?.defaultCCode + phnNo} </span>
  //               </>
  //             )}
  //           </>
  //         )}
  //       </span>
  //     </Typography>
  //   </Grid>
  // );

  const newButton = !timeOutButton ? (
    <Grid className={otp.length < 4 || disableButton ? css.verifyBgClr2 : css.verifyBgClr1}>
      <Button
        className={css.button}
        onClick={handleOtpVerify}
        disabled={otp.length < 4 || disableButton}
      >
        <FormattedMessage id="guestotp_continue" defaultMessage="Verify" />
      </Button>
    </Grid>
  ) : (
    <Grid className={css.verifyBgClr1}>
      <Button className={css.button} onClick={() => navigate('/login')}>
        <FormattedMessage id="backToLogin" defaultMessage="Back to Login" />
      </Button>
    </Grid>
  );

  if (!otpId && !phnNo) {
    navigate(`/${intl.locale}/login`, { replace: true });
  }

  const handleEmailLogin = () => {
    otpViaEmailGA(userType);
    // return
    if (email) {
      requestOtpEmailGA();
      dispatch(
        sendOtp({
          cCode: countryValidations?.defaultCCode,
          phnNo: phnNo,
          email: email,
          otpId: otpId,
          sendOtpVia: 'OTP',
          country: countryName,
          otpVia: 'EMAIL',
        })
      )
        .then((resp) => {
          otpResponseEmailGA('Exist');
          navigate(`/${intl.locale}/verifyOTPGuest`, {
            replace: true,
            state: {
              cCode: countryValidations?.defaultCCode,
              phnNo: phnNo,
              email: email,
              retUrl: retUrl,
              otpId: otpId,
              oldLocation: oldLocation,
              isEmailVerify: true,
            },
          });
        })
        .catch((error) => {
          // setDisableSubmit(false);
          // TODO: Handle send otp error
        });
    } else {
      navigate(`/${intl.locale}/email-otp`, {
        state: {
          cCode: countryValidations?.defaultCCode,
          phnNo: phnNo,
          retUrl: retUrl,
          otpId: otpId,
          oldLocation: oldLocation,
        },
      });
      // console.log('navigate to page');
    }
  };
  const handleBack = () => {
    navigate(-1);
  };
  const titleDesc = (
    <Grid className={css.textContainer}>
      <Grid>
        <IconButton className={css.backButton} onClick={handleBack}>
          {'<'}
        </IconButton>
      </Grid>
      <Grid>
        <Grid className={css.headerText}>
          <Typography>
            {phnNo ? (
              <FormattedMessage id="codeSent" defaultMessage="Code Sent" />
            ) : (
              <FormattedMessage id="pleaseEnterThe" defaultMessage="Please Enter The" />
            )}
          </Typography>
        </Grid>
        <Grid className={css.headerText + ' ' + css.boldText}>
          <Typography>
            {phnNo ? (
              <FormattedMessage id="toYourNumber" defaultMessage="To Your Number" />
            ) : (
              <FormattedMessage id="4DigitOtp" defaultMessage="4 Digit OTP" />
            )}
          </Typography>
        </Grid>
      </Grid>
      <Typography className={css.secondaryText}>
        {phnNo ? (
          <FormattedMessage
            id="guestotp_otp"
            values={{ number: phnNo }}
            defaultMessage={`We sent in OTP to the number ${phnNo}`}
          />
        ) : (
          <FormattedMessage
            id="guestotp_email"
            values={{ email: email?.substring(0, 2) + '*****@' + email?.split('@')?.at(1) }}
            defaultMessage={`OTP sent to ${email}`}
          />
        )}
      </Typography>
    </Grid>
  );
  return (
    <Grid className={css.root}>
      {pageLoader && <Loader />}
      {/* <TopBar heading={<FormattedMessage id="otp" defaultMessage="One Time Password" />} /> */}
      {/* {!isDesktop && (
        <MobileHeader
          // icon={<FaArrowLeft onClick={handleLogin} />}
          title={<FormattedMessage id="otp" defaultMessage="One Time Password" />}
        />
      )} */}
      <Grid>
        {titleDesc}
        <Paper className={css.otpContainer}>
          <Grid>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={maxLength}
              isInputNum={true}
              containerStyle={css.otpField}
              shouldAutoFocus={true}
            />
          </Grid>
          <Grid>
            <Grid className={css.buttons}>
              {timerDuration > 0 ? (
                <Typography className={css.timeLimit}>
                  00:{timerDuration.toLocaleString(undefined, { minimumIntegerDigits: 2 })}
                </Typography>
              ) : (
                <Typography className={css.requestDisable}>
                  <FormattedMessage id="didn'tReceiveCode" defaultMessage="Didn't receive code?" />
                </Typography>
              )}

              <Typography
                className={timerDuration > 0 ? css.requestDisable : css.requestEnable}
                onClick={handleResendOtp}
              >
                <FormattedMessage id="requestAgain" defaultMessage="REQUEST AGAIN" />
              </Typography>

              {/* <Grid item xs={3} className={css.verifyOtpBtn}></Grid> */}
            </Grid>
            <Grid className={css.warningText}>{errorText}</Grid>
            {timerDuration > 0 ? null : (
              <>
                {!auth?.otpState?.data?.email || auth?.otpState?.data?.email === '' ? (
                  <Grid className={css.reqEmail}>
                    <Button className={css.emailBtn} onClick={handleEmailLogin}>
                      <FormattedMessage id="OTPonEmail" defaultMessage="Get OTP on email" />
                    </Button>
                  </Grid>
                ) : (
                  ''
                )}
              </>
            )}
            {newButton}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default GuestOTP;
